import React from 'react';
export function ProcessSection() {
  return <section className="bg-gray-light py-20 px-4" data-id="element-142">
      <div className="max-w-5xl mx-auto" data-id="element-143">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-16 text-center" data-id="element-144">
          Así de simple funciona
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-145">
          {/* Step 1 */}
          <div className="bg-white rounded-xl p-8 shadow-md relative mt-8 md:mt-0" data-id="element-146">
            <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 w-16 h-16 bg-gold rounded-full flex items-center justify-center text-navy-dark font-bold text-2xl shadow-lg border-4 border-white" data-id="element-147">
              1
            </div>
            <h3 className="text-xl font-bold text-navy mb-4 mt-6 text-center" data-id="element-148">
              Prepara el Terreno
            </h3>
            <p className="text-text-muted text-center" data-id="element-149">
              Limpias tu perfil actual y activas tus reportes con tu ITIN o SSN
              siguiendo la guía.
            </p>
          </div>

          {/* Step 2 */}
          <div className="bg-white rounded-xl p-8 shadow-md relative mt-8 md:mt-0" data-id="element-150">
            <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 w-16 h-16 bg-gold rounded-full flex items-center justify-center text-navy-dark font-bold text-2xl shadow-lg border-4 border-white" data-id="element-151">
              2
            </div>
            <h3 className="text-xl font-bold text-navy mb-4 mt-6 text-center" data-id="element-152">
              Construye la Base
            </h3>
            <p className="text-text-muted text-center" data-id="element-153">
              Aplicas a los 2 "Ladrillos Iniciales" (tarjetas específicas) que
              te recomendamos.
            </p>
          </div>

          {/* Step 3 */}
          <div className="bg-white rounded-xl p-8 shadow-md relative mt-8 md:mt-0" data-id="element-154">
            <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 w-16 h-16 bg-gold rounded-full flex items-center justify-center text-navy-dark font-bold text-2xl shadow-lg border-4 border-white" data-id="element-155">
              3
            </div>
            <h3 className="text-xl font-bold text-navy mb-4 mt-6 text-center" data-id="element-156">
              Crece y Mantén
            </h3>
            <p className="text-text-muted text-center" data-id="element-157">
              Aplicas la Regla de Oro del 30% y observas cómo tu puntaje sube
              mes tras mes.
            </p>
          </div>
        </div>

        {/* Proof Box */}
        <div className="bg-white border-2 border-gold rounded-xl p-8 md:p-10 shadow-xl max-w-3xl mx-auto text-center relative" data-id="element-158">
          <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-gold text-navy-dark font-bold px-6 py-1 rounded-full text-sm uppercase tracking-wide" data-id="element-159">
            Resultados Rápidos
          </div>
          <p className="text-xl md:text-2xl font-heading text-navy leading-relaxed italic" data-id="element-160">
            "En los próximos 7 días, después de aplicar el Capítulo 4 (Usuario
            Autorizado), verás por primera vez tu nombre aparecer en los
            monitores de crédito. No es magia, es cómo funciona el algoritmo
            bancario cuando le das la información que quiere ver."
          </p>
        </div>
      </div>
    </section>;
}